import { GetResults } from "./getResults";

import { processIdentifyResults } from "./processIdentifyResults";

export async function executeIdentify(event) {    
  let identifyResults = await GetResults(event);
  let featureArray = await processIdentifyResults(identifyResults); 



  return featureArray; 
}

  
  